var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoLg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 204.7 59",
    style: {
      enableBackground: "new 0 0 204.7 59"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{enable-background:new    ;}\n\t.st2{fill:#F96701;}\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#F96701;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 18.9,
    className: "st0",
    width: 140,
    height: 20.9
  }), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M65.1,34.6h4c0.4,1.8,1.5,2.5,4,2.5c2.1,0,3.7-0.4,3.7-1.9c0-3.3-11.3-1-11.3-6.8c0-3,2.8-4.6,7.3-4.6 c5,0,7.3,1.9,7.5,5.1h-3.9c-0.2-1.6-1.1-2.5-3.8-2.5c-2,0-3.3,0.5-3.3,1.7c0,3,11.3,1.2,11.3,6.8c0,3.2-3,4.8-7.8,4.8 C68.2,39.8,65.4,38.2,65.1,34.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M91.7,27.1h-3.8v12.4H84V18.9h3.9v5.2h5.2c3.7,0,6.4,2,6.4,6.2v9.2h-3.9v-8.8C95.5,28,94.2,27.1,91.7,27.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M102.4,31.8c0-5.2,4-8,9-8s9,2.8,9,8s-4,8-9,8S102.4,37.1,102.4,31.8z M111.3,36.9c2.8,0,5-1.7,5-5.1 s-2.1-5.1-5-5.1c-2.8,0-5,1.7-5,5.1C106.4,35.3,108.5,36.9,111.3,36.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M123,31.8c0-5.2,4-8,9-8c4.6,0,7.7,2.3,8.5,5.5h-4.2c-0.6-1.4-2-2.6-4.3-2.6c-2.8,0-5,1.7-5,5.1 s2.1,5.1,5,5.1c2.4,0,3.8-1.2,4.3-2.6h4.2c-0.9,3.2-4,5.5-8.5,5.5C127,39.8,123,37.1,123,31.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M159,39.3v0.2h-4.4l-4.2-6.8h-3v6.8h-3.9V18.9h3.9v10.8h3l4.2-5.6h4.4v0.2l-5.3,6.7v0.3L159,39.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M160.2,31.8c0-5.2,4-8,9-8s9,2.8,9,8s-4,8-9,8S160.2,37.1,160.2,31.8z M169.1,36.9c2.8,0,5-1.7,5-5.1 s-2.1-5.1-5-5.1s-5,1.7-5,5.1C164.2,35.3,166.3,36.9,169.1,36.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M180.8,31.8c0-5,3.8-8,8.9-8c5.3,0,9.3,3.1,8.9,9h-13.8c0.4,2.7,2.2,4.2,4.9,4.2c2,0,3.5-0.9,4.2-2.4h4.2 c-1.1,3.3-4.4,5.2-8.4,5.2C184.5,39.8,180.8,36.9,180.8,31.8z M194.5,30.2c-0.5-2.3-2.3-3.7-4.8-3.7c-2.6,0-4.3,1.5-4.8,3.7H194.5 z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M51,29.5h-3.2V8.7H27V5.5h24V29.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M27,53.5H14.2C8,53.5,3,48.5,3,42.3V29.5h3.2v12.8c0,4.4,3.6,8,8,8H27V53.5z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 12.8,
    className: "st0",
    width: 24.5,
    height: 27.1
  }), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M16.6,32.8h5.1c0.5,2.3,2,3.2,5.1,3.2c2.7,0,4.7-0.5,4.7-2.4c0-4.2-14.4-1.3-14.4-8.7c0-3.8,3.6-5.9,9.4-5.9 c6.3,0,9.3,2.4,9.6,6.5h-5c-0.3-2.1-1.4-3.1-4.8-3.1c-2.6,0-4.2,0.6-4.2,2.1c0,3.8,14.5,1.6,14.5,8.7c0,4.1-3.8,6.2-9.9,6.2 C20.5,39.5,16.9,37.3,16.6,32.8z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLg);
export default __webpack_public_path__ + "static/media/logo-lg.f71ee6d635a2a71d7037c251c9a85ab8.svg";
export { ForwardRef as ReactComponent };